/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type QueryPatientAuditContactTooltip_EmbedQueryVariables = {
    id: string;
};
export type QueryPatientAuditContactTooltip_EmbedQueryResponse = {
    readonly patientById: {
        readonly createdAt: unknown | null;
        readonly auditContact: {
            readonly timestamp: string | null;
            readonly id: string;
        } | null;
    } | null;
};
export type QueryPatientAuditContactTooltip_EmbedQuery = {
    readonly response: QueryPatientAuditContactTooltip_EmbedQueryResponse;
    readonly variables: QueryPatientAuditContactTooltip_EmbedQueryVariables;
};



/*
query QueryPatientAuditContactTooltip_EmbedQuery(
  $id: MongoID!
) {
  patientById(_id: $id) {
    createdAt
    auditContact: audit(filter: {modelField: "contact", operation: "update", result: "success"}) {
      timestamp
      id
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "_id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": "auditContact",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "modelField": "contact",
        "operation": "update",
        "result": "success"
      }
    }
  ],
  "concreteType": "Audit",
  "kind": "LinkedField",
  "name": "audit",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timestamp",
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": "audit(filter:{\"modelField\":\"contact\",\"operation\":\"update\",\"result\":\"success\"})"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QueryPatientAuditContactTooltip_EmbedQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Patient",
        "kind": "LinkedField",
        "name": "patientById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QueryPatientAuditContactTooltip_EmbedQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Patient",
        "kind": "LinkedField",
        "name": "patientById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8fb090eb44c253f8fa561a1e2ae53bbe",
    "id": null,
    "metadata": {},
    "name": "QueryPatientAuditContactTooltip_EmbedQuery",
    "operationKind": "query",
    "text": "query QueryPatientAuditContactTooltip_EmbedQuery(\n  $id: MongoID!\n) {\n  patientById(_id: $id) {\n    createdAt\n    auditContact: audit(filter: {modelField: \"contact\", operation: \"update\", result: \"success\"}) {\n      timestamp\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '5186dd6f608a19df4d91ffcbbae210be';
export default node;
